import type { Arrayable } from 'element-plus/es/utils'
import { storeToRefs } from 'pinia'
import { ensureArray, isNilOrEmpty } from 'ramda-adjunct'
import { useProfileStore } from '../store'
import { permissionMatcher, PermissionScope } from '../types'

export function usePermission() {
  const { permissions, scope, isSuper } = storeToRefs(useProfileStore())

  function checkPermission(permission: Arrayable<string>) {
    if (scope.value === PermissionScope.system && isSuper.value) {
      // 系统后台超管有所有权限
      return true
    }

    const permissionsToTest = ensureArray(permission)
    if (isNilOrEmpty(permissionsToTest)) {
      return false
    }

    return permissionsToTest.some((p) => {
      return permissions.value.some(permissionMatcher(p))
    })
  }

  return {
    checkPermission,
  }
}
